const endUserPathPrefix = "/end_user";
let Pages = {
    /** common pages **/
    login: {name: "login", path: "/login"},
    basicLogin: {name: "basicLogin", path: "/basicLogin"},
    register: {name: "register", path: "/register"},
    resetPassword:{name: "resetPassword", path: "/resetPassword"},
    confirmPasswordToRegister: {name: "confirmPasswordToRegister", path: "/confirmPasswordToRegister"},
    commerceLawRules: {name: "commerceLawRules", path: "/commerceLawRules"},
    confirmSendEmailToRegisterAddress: {
        name: "confirmSendEmailToRegisterAddress",
        path: "/confirmSendEmailToRegisterAddress"
    },
    registerEndUserBaseInfo: {name: "registerEndUserBaseInfo", path: "/registerEndUserBaseInfo"},
    confirmRegisterInformation: {name: "confirmRegisterInformation", path: "/confirmRegisterInformation"},
    home: {name: "home", path: "/home"},
    bookingCalendar: { name: "bookingCalendar", path: '/bookingCalendar'},
    redirect: {name: "redirect", path: "/redirect"},
    notFound: {name: "notFound", path: "/not-found"},
    forbidden: {name: "forbidden", path: "/forbidden"},
    myPage: {name: "myPage", path: "/myPage"},
    /**End user**/
    oldBookingConfirm: {name: "oldBookingConfirm", path: `/myPage/oldBookingConfirm`},
    bookingConfirm: {name: "bookingConfirm", path: `/myPage/bookingConfirm`},
    changeBookingDate: {name: "changeBookingDate", path: `/changeBookingDate`},
    changePassword: {name: "changePassword", path: `${endUserPathPrefix}/changePassword`},
    orderBooking: {name: "orderBooking", path: `${endUserPathPrefix}/orderBooking`},
    changeInformation: {name: "changeInformation", path: `${endUserPathPrefix}/changeInformation`},
    changeEmail: {name: "changeEmail", path: `${endUserPathPrefix}/changeEmail`},
    confirmToChangeEmail: {name: "confirmToChangeEmail", path: `${endUserPathPrefix}/confirmToChangeEmail`},
    changePasswordAfterConfirm: {name: "changePasswordAfterConfirm", path:`/resetPassword/changePassword`},
    viewSystemRules: {name: "viewSystemRules", path: `${endUserPathPrefix}/viewSystemRules`},

    browserSupportAlert: {name: "browserSupportAlert", path: '/browserSupportAlert'}
};

export default Pages;
